import classNames from 'classnames';
import { ProductFactsheetLink } from 'components/product-factsheet-link';
import { ProductVideoButton } from 'components/product-video-button';
import { ProductPinnedButton } from 'components/shared/ProductAndClientSelector/ProductPinnedButton';
import { useTranslateProductName } from 'hooks/use-translate-payoff';
import { ProductHelpCenterAction } from 'models';
import { ProductVariation } from 'models/productsReferential';
import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { getProductNameForAnalytics } from 'utils/productVariation';

type ProductListItemProps = {
  product: ProductVariation;
  isActive: boolean;
  isPinned: boolean;
  onSelect: (product: ProductVariation) => void;
};

export function ProductListItem({ product, isActive, isPinned, onSelect }: ProductListItemProps) {
  const { productName, productTypeLabel, productSubtypeLabel } = useTranslateProductName(
    product.productType,
    product.productSubType,
  );

  const onClickLearnMore = (action: ProductHelpCenterAction) => {
    logAnalytics.trackEvent('Primary market essential product selector', action, getProductNameForAnalytics(product));
  };

  return (
    <ScrollIntoViewIfNeeded
      className={classNames(
        'list-group-item list-group-item-action border-bottom border-opacity-40 d-flex align-items-center justify-content-between py-1 ps-3 pe-2 gap-3',
        isActive && 'active list-group-item-info',
      )}
      role="button"
      active={isActive}
      onClick={() => onSelect(product)}
      aria-label={productName}
    >
      <div>
        <span className="text-secondary">{productTypeLabel}</span>
        <span className="text-secondary"> / </span>
        <span>{productSubtypeLabel}</span>
      </div>
      <div className="d-flex">
        <ProductVideoButton product={product} onClick={() => onClickLearnMore('Start video')} />
        <ProductFactsheetLink product={product} onClick={() => onClickLearnMore('Download factsheet')} />
        <ProductPinnedButton
          productVariation={product}
          tabType="catalogue"
          workspace="essential"
          iconName={isPinned ? 'star' : 'star_outline'}
        />
      </div>
    </ScrollIntoViewIfNeeded>
  );
}
